module.exports = __webpack_public_path__ + "img/app-paw.ba6a18b5.svg";